module.exports = __webpack_public_path__ + "img/person-2_fill.321b02bb.svg";